import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { products } from "@/mocks/products";

const categories = [
  { key: "shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
  { key: "hoodies", url: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
  { key: "tshirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
  { key: "jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
  { key: "pants", url: "https://kaspreadsheet.com/search-915/name/Shoes.html" },
  { key: "headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html" },
  { key: "sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html" },
  { key: "underwear", url: "https://kaspreadsheet.com/search-918/name/Shoes.html" },
  { key: "jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html" },
  { key: "accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html" },
  { key: "bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html" },
  { key: "belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html" },
  { key: "perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html" },
  { key: "other", url: "https://kaspreadsheet.com/search-924/name/Shoes.html" },
];

const resources = [
  { key: "spreadsheet", path: "allchinabuy-spreadsheet", icon: "ri-table-line" },
  { key: "finds", path: "allchinabuy-finds", icon: "ri-search-line" },
  { key: "products", path: "allchinabuy-products", icon: "ri-shopping-bag-line" },
  { key: "shippingResource", path: "allchinabuy-shipping", icon: "ri-truck-line" },
  { key: "qcResource", path: "allchinabuy-qc", icon: "ri-shield-check-line" },
  { key: "warehouse", path: "allchinabuy-warehouse", icon: "ri-building-2-line" },
  { key: "review", path: "allchinabuy-review", icon: "ri-star-line" },
  { key: "coupon", path: "allchinabuy-coupon", icon: "ri-coupon-line" },
];

const guides = [
  { key: "reviewGuide", path: "allchinabuy-review" },
  { key: "shippingCost", path: "allchinabuy-shipping" },
  { key: "warehouseGuide", path: "allchinabuy-warehouse" },
  { key: "qcGuide", path: "allchinabuy-qc" },
  { key: "safetyGuide", path: "allchinabuy-safety" },
  { key: "couponGuide", path: "allchinabuy-coupon" },
];

const featuredProducts = products.slice(0, 8);

const whyItems = [
  { key: "organized", icon: "ri-folder-5-line" },
  { key: "discovery", icon: "ri-search-2-line" },
  { key: "practical", icon: "ri-book-open-line" },
  { key: "shippingInfo", icon: "ri-truck-line" },
  { key: "multilingual", icon: "ri-global-line" },
  { key: "updated", icon: "ri-refresh-line" },
];

const articles = [
  { title: "Complete AllChinaBuy Spreadsheet Guide 2026", path: "allchinabuy-spreadsheet", desc: "Everything you need to know about the AllChinaBuy spreadsheet, how to use it, and where to find the best products. Updated for 2026.", date: "2026-08-20" },
  { title: "AllChinaBuy Review: Shipping, QC & Warehouse", path: "allchinabuy-review", desc: "An honest, independent review covering AllChinaBuy shipping experience, quality control process, and warehouse handling.", date: "2026-08-18" },
  { title: "AllChinaBuy Shipping Cost Guide", path: "allchinabuy-shipping", desc: "Understand shipping methods, potential costs, timelines, and tracking options before you place your order.", date: "2026-08-15" },
];

export default function HomePage() {
  const { t } = useTranslation();
  const { lang = "en" } = useParams<{ lang?: string }>();

  const getPath = (page: string) => `/${lang}/${page}`;

  return (
    <div>
      {/* Hero Section */}
      <section className="relative overflow-hidden">
        {/* Background image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20fashion%20items%20sneakers%20hoodies%20accessories%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%20style%2C%20pastel%20warm%20tones%2C%20minimal%20aesthetic%20with%20subtle%20shadows&width=1600&height=900&seq=hero-bg&orientation=landscape"
            alt="Fashion products background"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-50/90 via-background-50/70 to-background-50/40" />
        </div>

        <div className="relative z-10 container-limit mx-auto px-4 md:px-6 lg:px-8 py-16 md:py-24 lg:py-32">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 text-xs font-medium px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 mb-6">
              <i className="ri-shield-check-line" />
              {t("hero.trustText")}
            </span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-6">
              {t("hero.h1")}
            </h1>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-8 max-w-2xl">
              {t("hero.subtitle")}
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="btn-primary text-base"
              >
                <i className="ri-external-link-line mr-2" />
                {t("hero.mainCta")}
              </a>
              <Link to={getPath("allchinabuy-spreadsheet")} className="btn-secondary text-base">
                <i className="ri-book-open-line mr-2" />
                {t("hero.secondaryCta")}
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* What Is Section */}
      <section className="section-padding bg-background-50">
        <div className="container-limit mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              {t("whatIs.h2")}
            </h2>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-8">
              {t("whatIs.description")}
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="btn-primary inline-flex"
            >
              {t("allChinaBuy.title")}
              <i className="ri-arrow-right-line ml-2" />
            </a>
          </div>
        </div>
      </section>

      {/* Category Buttons Grid */}
      <section className="section-padding bg-background-100">
        <div className="container-limit mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center">
            {t("categories.title")}
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
            {categories.map((cat) => (
              <a
                key={cat.key}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group flex flex-col items-center justify-center p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200"
              >
                <i className="ri-shopping-bag-3-line text-2xl text-foreground-400 group-hover:text-primary-500 mb-2 transition-colors" />
                <span className="text-sm font-medium text-foreground-700 group-hover:text-foreground-950 text-center leading-tight">
                  {t(`categories.${cat.key}`)}
                </span>
              </a>
            ))}
          </div>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="btn-primary text-sm"
            >
              <i className="ri-external-link-line mr-2" />
              {t("allChinaBuy.title")}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="btn-accent text-sm"
            >
              <i className="ri-shopping-cart-line mr-2" />
              {t("allChinaBuy.buyNow")}
            </a>
          </div>
        </div>
      </section>

      {/* Resources Section */}
      <section className="section-padding bg-background-50">
        <div className="container-limit mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center">
            {t("resources.h2")}
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {resources.map((res) => (
              <Link
                key={res.key}
                to={getPath(res.path)}
                className="group flex flex-col items-center p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 hover:shadow-sm transition-all duration-200"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 mb-3 group-hover:bg-primary-100 transition-colors">
                  <i className={`${res.icon} text-xl`} />
                </div>
                <span className="text-sm font-medium text-foreground-800 text-center group-hover:text-foreground-950 transition-colors">
                  {t(`resources.${res.key}`)}
                </span>
                <i className="ri-arrow-right-line mt-2 text-foreground-400 group-hover:text-primary-500 transition-colors" />
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Latest Finds Section */}
      <section className="section-padding bg-background-100">
        <div className="container-limit mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center">
            {t("latestFinds.h2")}
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {featuredProducts.map((product) => (
              <div key={product.id} className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-200 flex flex-col h-full" data-product-shop="">
                <div className="relative aspect-square overflow-hidden bg-background-100">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-2 left-2">
                    <span className="text-xs font-medium px-2 py-1 rounded-full bg-accent-100 text-accent-800">
                      {product.category}
                    </span>
                  </div>
                </div>
                <div className="p-3 md:p-4 flex flex-col flex-1">
                  <h3 className="text-sm font-medium text-foreground-950 leading-snug mb-2 line-clamp-2 flex-1">
                    {product.name}
                  </h3>
                  <div className="flex items-center justify-between gap-2 mt-auto pt-2 border-t border-background-200/50">
                    <div className="flex flex-col">
                      <span className="text-sm font-semibold text-primary-700">{product.price}</span>
                      <span className="text-xs text-foreground-400">{product.priceCNY}</span>
                    </div>
                    <a
                      href={product.link}
                      target="_blank"
                      rel="noopener nofollow"
                      className="btn-primary text-xs px-2.5 py-1.5 whitespace-nowrap"
                    >
                      <i className="ri-shopping-cart-line mr-1" />
                      {t("products.buy")}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
            <Link
              to={getPath("products")}
              className="btn-primary text-sm inline-flex"
            >
              <i className="ri-grid-line mr-2" />
              View All Products
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="btn-secondary text-sm inline-flex"
            >
              {t("latestFinds.cta")}
              <i className="ri-arrow-right-line ml-2" />
            </a>
          </div>
        </div>
      </section>

      {/* Guides Section */}
      <section className="section-padding bg-background-50">
        <div className="container-limit mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center">
            {t("guides.h2")}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {guides.map((guide) => (
              <Link
                key={guide.key}
                to={getPath(guide.path)}
                className="group flex items-center gap-4 p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 shrink-0 group-hover:bg-secondary-200 transition-colors">
                  <i className="ri-file-list-3-line text-lg" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors">
                    {t(`guides.${guide.key}`)}
                  </h3>
                </div>
                <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-500 transition-colors" />
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Shipping & QC Section */}
      <section className="section-padding bg-background-100">
        <div className="container-limit mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                {t("shipping.h2")}
              </h2>
              <p className="text-base text-foreground-700 leading-relaxed mb-6">
                {t("shipping.description")}
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <Link to={getPath("allchinabuy-shipping")} className="btn-primary text-sm">
                  {t("guides.shippingCost")}
                  <i className="ri-arrow-right-line ml-2" />
                </Link>
                <Link to={getPath("allchinabuy-warehouse")} className="btn-secondary text-sm">
                  {t("guides.warehouseGuide")}
                </Link>
              </div>
            </div>
            <div className="relative rounded-lg overflow-hidden aspect-video">
              <img
                src="https://readdy.ai/api/search-image?query=Minimal%20packaging%20boxes%20and%20shipping%20materials%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20logistics%20aesthetic&width=800&height=450&seq=shipping-bg&orientation=landscape"
                alt="Shipping and packaging"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-900/30 to-transparent" />
            </div>
          </div>
        </div>
      </section>

      {/* Safety Section */}
      <section className="section-padding bg-background-50">
        <div className="container-limit mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              {t("safety.h2")}
            </h2>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-8">
              {t("safety.description")}
            </p>
            <Link to={getPath("allchinabuy-safety")} className="btn-primary text-sm inline-flex">
              <i className="ri-shield-check-line mr-2" />
              {t("safety.cta")}
            </Link>
          </div>
        </div>
      </section>

      {/* Why Us Section */}
      <section className="section-padding bg-background-100">
        <div className="container-limit mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8 md:mb-12 text-center">
            {t("whyUs.h2")}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {whyItems.map((item) => (
              <div key={item.key} className="flex flex-col items-center text-center p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-50 text-accent-600 mb-4">
                  <i className={`${item.icon} text-xl`} />
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">
                  {t(`whyUs.${item.key}`)}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {t(`whyUs.${item.key}Desc`)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Articles Section */}
      <section className="section-padding bg-background-50">
        <div className="container-limit mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center">
            {t("articles.h2")}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {articles.map((article, index) => (
              <Link
                key={index}
                to={getPath(article.path)}
                className="group flex flex-col bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 p-5 md:p-6 transition-all duration-200"
              >
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded">
                    {t("common.readMore")}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-700 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-4">
                  {article.desc}
                </p>
                <span className="inline-flex items-center text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                  {t("articles.readMore")}
                  <i className="ri-arrow-right-line ml-1" />
                </span>
              </Link>
            ))}
          </div>
          <div className="mt-8 text-center">
            <Link to={getPath("allchinabuy-spreadsheet")} className="btn-secondary text-sm">
              {t("hero.secondaryCta")}
              <i className="ri-arrow-right-line ml-2" />
            </Link>
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="section-padding bg-background-100">
        <div className="container-limit mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              {t("bottomCta.h2")}
            </h2>
            <p className="text-base text-foreground-700 mb-8 leading-relaxed">
              {t("bottomCta.description")}
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="btn-primary text-base"
              >
                <i className="ri-external-link-line mr-2" />
                {t("bottomCta.secondaryCta")}
              </a>
              <Link to={getPath("allchinabuy-spreadsheet")} className="btn-secondary text-base">
                <i className="ri-book-open-line mr-2" />
                {t("bottomCta.primaryCta")}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}